/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FolderPen = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M8.4 10.6a2 2 0 0 1 3 3L6 19l-4 1 1-4Z" }],
    [
      "path",
      {
        d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5"
      }
    ]
  ]
];

export { FolderPen as default };
//# sourceMappingURL=folder-pen.js.map
